import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Cursor from './components/Cursor';
import Toast from './components/Toast';
import ScrollToTop from './components/ScrollToTop';
import StickyMobileCTA from './components/StickyMobileCTA';

import Home            from './pages/Home';
import Products        from './pages/Products';
import Services        from './pages/Services';
import Blog            from './pages/Blog';
import BlogPost        from './pages/BlogPost';
import Portfolio       from './pages/Portfolio';
import Contact         from './pages/Contact';
import BookOnline      from './pages/BookOnline';
import PrivacyPolicy   from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import RefundPolicy    from './pages/RefundPolicy';
import Accessibility   from './pages/Accessibility';
import NotFound        from './pages/NotFound';

export const ToastContext = React.createContext(null);

export default function App() {
  const [toast, setToast] = useState(null);
  const showToast = (msg, type = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 4500);
  };
  return (
    <ToastContext.Provider value={showToast}>
      <Cursor />
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/"               element={<Home />} />
          <Route path="/products"            element={<Products />} />
          <Route path="/products/:slug"      element={<Products />} />
          <Route path="/services"             element={<Services />} />
          <Route path="/services/:slug"       element={<Services />} />
          <Route path="/blog"                 element={<Blog />} />
          <Route path="/blog/:slug"            element={<BlogPost />} />
          <Route path="/portfolio"      element={<Portfolio />} />
          <Route path="/contact"        element={<Contact />} />
          <Route path="/book-online"    element={<BookOnline />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms"          element={<TermsConditions />} />
          <Route path="/refund-policy"  element={<RefundPolicy />} />
          <Route path="/accessibility"  element={<Accessibility />} />
          <Route path="*"               element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <StickyMobileCTA />
      {toast && <Toast msg={toast.msg} type={toast.type} onClose={() => setToast(null)} />}
    </ToastContext.Provider>
  );
}
